import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { productGridStyles } from './ProductGrid.styles';

export type ProductGridProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export function ProductGrid({ className, children, ...props }: ProductGridProps): JSX.Element {
  return (
    <div className={cn(productGridStyles.root, className)} {...props}>
      {children}
    </div>
  );
}
